import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  deleteOneProperty,
  fetchOneProperty,
} from "../../helpers/api/condominium";
import PageHeader from "../common/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import handleErrorMessage, { getErrorMessage } from "../../helpers/errors/handleErrorMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonIcon from "../common/ButtonIcon";
import { faInfoCircle, faMinus } from "@fortawesome/free-solid-svg-icons";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { useHistory } from "react-router-dom";
import ProfileBanner from "./profile/ProfileBanner";
import SupportLink from "../root/support/components/SupportLink";
import ProfileContact from "./profile/ProfileContact";
import { useForm } from "react-hook-form";
import { updatedUserProfile } from "../../actions/authActions";
import { fetchWithAuthorization } from "../../helpers/api/fetch";
import ProfileBasicAdmin from "./profile/ProfileBasicAdmin";
import ProfilePasswordAdmin from "./profile/ProfilePasswordAdmin";

const PropertyEdit = ({ setRedirect, setRedirectUrl }) => {
  const { property } = useParams();
  const history = useHistory();
  const { condominium } = useSelector((state) => state.condominium);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const {
    handleSubmit,
    register,
    setValue,
    setError: setFieldError,
    clearErrors: clearFieldErrors,
    formState: { errors },
  } = useForm();
  const [wasBeEdited, setWasBeEdited] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (property) {
      (async () => {
        fetchOneProperty({ propertyId: property })
          .then((val) => {
            isMounted && setData(val.data);
          })
          .catch((error) => {
            isMounted && setError(error);
            handleErrorMessage(error);
          })
          .finally(() => {
            isMounted && setIsLoading(false);
          });
      })();
    }
    return () => {
      isMounted = false;
    };
  }, [property]);

  const handleDelete = () => {
    collapseOneOpen(false);
    deleteProp();
  };

  const handleModal = () => {
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Eliminar propietario</ModalHeader>
      <ModalBody>
        <p className="mb-0 font-weight-bold fs--1">
          ¿Está seguro de eliminar el propietario {data.user?.data.firstname}{" "}
          {data.user?.data.lastname}?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
        <Button
          data-testid="delete-button"
          color="danger"
          onClick={handleDelete}
        >
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>;
  };

  /*   const loadData = () => {
    setUserData({});
    setLoading(true);
    checkUserToken(token)
      .then(({ username, data }) => {
        setUsername(username);
        setUserData(data);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  }; */

  const updateData = async (e) => {
    clearFieldErrors();
    try {
      setLoading(true);
      // HO-HU-37: se manda el ID de la PROPERTY (data.id), no el de la
      // cuenta (data.user.id) -- si la cuenta ya tiene varias propiedades,
      // usar el id de cuenta era ambiguo (el backend resolvia "alguna" de
      // sus propiedades, no necesariamente esta que se esta viendo/editando
      // en pantalla).
      const { code } = await fetchWithAuthorization(
        `/profile/update/${data?.id}`,
        e,
        "PUT"
      );
      if (code === SUCCESS_RESPONSE.OK) {
        setError(null);
        dispatch(updatedUserProfile(e));
        /*  loadData(); */
        Toast.fire({
          type: "success",
          title: "Datos actualizados con exito.",
        });
      }
    } catch (e) {
      setError(e);
      Object.entries(e?.errors || {}).forEach(([field, messages]) => {
        setFieldError(field, { type: "server", message: messages[0] });
      });
    } finally {
      setWasBeEdited(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error !== null && error.errors?.email?.[0]) {
      Toast.fire({
        type: "error",
        title: error.errors.email[0],
      });
    } else if (error !== null && error.error) {
      // HO-HU-37: el rechazo por correo duplicado en otro condominio
      // (updateProfileAdmin) viene como {"error": "..."} , no como
      // {"errors": {...}} de una validacion normal de Laravel.
      Toast.fire({
        type: "error",
        title: error.error,
      });
    } else if (error !== null) {
      Toast.fire({
        type: "error",
        title: getErrorMessage(error?.code),
      });
    }
  }, [error]);

  const deleteProp = async () => {
    try {
      const { code } = await deleteOneProperty(data.id);
      if (code === SUCCESS_RESPONSE.OK) {
        Toast.fire({
          type: "success",
          title: "Se ha eliminado el propietario satisfactoriamente.",
        });
        setRedirectUrl("/dashboard/properties/");
        setRedirect(true);
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const getDate = (date) => {
    const d = new Date(date);
    const meses = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];
    let hours = d.getHours();
    let minutes = d.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const strTime = hours + ":" + minutes + " " + ampm;
    return `${meses[d.getMonth()]
      } ${d.getDate()}, ${d.getFullYear()} ${strTime}`;
  };

  return (
    <>
      <PageHeader
        title={`Editar propietario del condominio ${condominium}`}
        titleTag="h2"
        description="Ve la información del propietario."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState cond={!!data.user} loading={isLoading}>
        <Or value={true}>
          <ProfileBanner
            edit={false}
            emphasis={`(${data.user?.username})`}
            firstname={data.user?.data.firstname}
            lastname={data.user?.data.lastname}
            image={data.user?.data.image}
            direction={data.user?.data.direction}
          >
            <Row className="justify-content-between align-items-center">
              <Col xs={6} className="d-flex align-items-center">
                <div className="media">
                  <FontAwesomeIcon icon="user" color="#00d27a" />
                </div>
                <div className="media-body ml-2">
                  <p className="mb-0">Propietario creado el</p>
                  <p className="fs--1 mb-0 text-600">
                    {getDate(data.user?.created_at)}
                  </p>
                </div>
              </Col>

            </Row>
          </ProfileBanner>
        </Or>
        <Or value={false} cond={!!error}>
          <Message
            className="p-3"
            color={"info"}
            icon={faInfoCircle}
            value={true}
          >
            <>No hay informacion para mostrar.</>
          </Message>
          <Message
            className="p-3"
            color={"danger"}
            icon={faInfoCircle}
            value={true}
          >
            <>
              Esta página no está disponible
              <Button
                data-testid="Button"
                color="link"
                size="sm"
                className="ml-1 pl-0"
                onClick={() => history.goBack()}
              >
                Volver
              </Button>
            </>
          </Message>
        </Or>
      </PreloadState>
      {handleModal()}
      {/*       {data ? (
        <ProfileBanner
          loadData={isLoading}
          image={data.user?.data.image}
          address={data.user?.data.address}
          firstname={data.user?.data.firstname || "... "}
          lastname={data.user?.data.lastname || " ..."}
        />
      ) : (
        <Loader />
      )} */}
      {/*       {error && (
        <Alert
          closeAriaLabel="x"
          onClick={(e) => setError(null)}
          color="warning"
          className="mb-3"
        >
          {error?.message}
        </Alert>
      )} */}
      <Card className="mb-3 bg-light">
        <CardBody>
          <PreloadState cond={!!data.user} loading={isLoading}>
            <Or value={true}>
              <Form onSubmit={handleSubmit(updateData)}>
                <ProfilePasswordAdmin
                  data={data}
                  username={data.user?.username}
                />
                <ProfileBasicAdmin
                  wasBeEdited={() => setWasBeEdited(true)}
                  edit={!isLoading}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  dni={data.user?.data.dni}
                  firstname={data.user?.data.firstname}
                  lastname={data.user?.data.lastname}
                  property={data.property}
                />
                <ProfileContact
                  wasBeEdited={() => setWasBeEdited(true)}
                  edit={!isLoading}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  phone={data.user?.data?.phone}
                  email={data.user?.data?.email}
                />

                <Row>
                  <Col className="d-flex justify-content-end align-items-center mt-3">
                    <ButtonIcon
                      data-testid="submit-button"
                      color="primary"
                      className="px-5"
                      type="submit"
                      icon="save"
                      disabled={isLoading || !wasBeEdited}
                      transform="down-1 shrink-4"
                    >
                      Actualizar
                    </ButtonIcon>
                  </Col>
                </Row>
              </Form>
            </Or>
            <Or value={false}>
              <></>
            </Or>
          </PreloadState>
        </CardBody>
      </Card>
    </>
  );
};

export default withRedirect(PropertyEdit);
